import { useCallback, useEffect, useState } from 'react';

export const useOutsideClick = <T extends Element>(callback: () => void) => {
    const [ref, setRef] = useState<T[]>([]);

    const handleSetRef = useCallback((target: T) => {
        setRef((prev) => [...prev, target]);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            if (ref.length && !ref.some((element) => element?.contains(event.target as Node))) {
                callback();
            }
        };

        document.addEventListener('click', handleClickOutside, true);

        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [ref, callback]);

    return handleSetRef;
};
